import React from 'react';
import { StatusBadge } from "./StatusBadge";
import { IStatusBadgeProps } from "./BadgeType";
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {Box, Grid} from "@material-ui/core";
import {EmedStyle} from "../style/emed.style";
import styles from './StatusBadge.module.scss';

const useStyles = makeStyles({
    root: {
        padding:0,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: 1,
        width: 14,
        height: 14,
        backgroundColor: '#f5f8fa',
        WebkitBoxShadow: "0px 0px 0px 1.25px rgba(0,0,0)",
        boxShadow: "0px 0px 0px 1.25px rgba(0,0,0)",
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        WebkitBoxShadow: "none",
        boxShadow: "none",
        '&:before': {
            display: 'block',
            width: 14,
            height: 14,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
        },
    },
    statusLabel: { fontWeight: 600, marginLeft:8 }
});



const useStylesSelectableBadge = makeStyles({
   root:{
       backgroundColor:(props:{type:BadgeVariant})=>{
           switch (props.type) {
               case BadgeVariant.critical:
                   return EmedStyle.EmedBadge.critical;
               case BadgeVariant.New:
                   return EmedStyle.EmedBadge.NewMed;

           }
       },
       flexWrap:"nowrap",
       whiteSpace:"nowrap",
       color:(props:{type:BadgeVariant})=>{
           switch (props.type) {
               case BadgeVariant.critical:
                   return "white";
               case BadgeVariant.New:
                   return "white";

           }
           return "unset"
       },
       fontSize: 12,
       fontWeight: 600,
       borderRadius: "2px",
       padding:8,
       maxWidth:"180px" //Set max width to prevent unchecked expansion of badge as resolution changes
   },
    checkBox:{
      padding:0 
    },
    icon: {
        borderRadius: 1,
        width: 14,
        height: 14,
        backgroundColor: '#f5f8fa',
        WebkitBoxShadow: "0px 0px 0px 1.25px rgba(0,0,0)",
        boxShadow: "0px 0px 0px 1.25px rgba(0,0,0)",
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        WebkitBoxShadow: "none",
        boxShadow: "none",
        '&:before': {
            display: 'block',
            width: 14,
            height: 14,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
        },
    },
    label:{
       display:"flex", 
        alignItems:"center",
        marginLeft:10
    }
});

export const SelectableCriticalBadge=(props:{
    label:string;
    checked?:boolean;
    onChange?:(event:any)=>void;
})=>{
    return <SelectableBadge kind={BadgeVariant.critical} {...props}/>;
}

export const SelectableNewBadge=(props:{
    label:string;
    checked?:boolean;
    onChange?:(event:any)=>void;
})=>{
    return <SelectableBadge kind={BadgeVariant.New} {...props}/>;
}


export enum BadgeVariant {
    critical,
    New,
    Success
}
export const SelectableBadge = (props:{
    kind:BadgeVariant;
    label:string;
    checked?:boolean;
    onChange?:(event:any)=>void;
})=>{
    const classes = useStyles();
    const changed = (e:any)=>{
        if (props.onChange){
            props.onChange(e);
        }
    }


    let badgeClassMap = new Map<BadgeVariant,string>([[BadgeVariant.critical,styles.criticalBadge],[BadgeVariant.New,styles.newMed]]);
    let badgeClass = badgeClassMap.get(props.kind);
    return <Box className={`${styles.statusBadge} ${badgeClass}`}>
            <Box className={styles.inline}>
                <Checkbox
                        className={classes.root}
                        disableRipple
                        color="default"
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        onChange={changed}
                        checked={props.checked}
                    />
            <span className={classes.statusLabel}>
                {props.label}
            </span>
                
            
        </Box>
        </Box>
}

export const StatusBadgeCheckbox = (props: {
    IStatusBadgeProps: IStatusBadgeProps,
    dispatch: React.Dispatch<any>,
    state: boolean,
    kind:BadgeVariant;
}) => {
    const classes = useStyles();
    const handleChange = (event: any) => {
        props.dispatch({ type: "BADGE_STATUS", status: event.target.checked })
    };
    const badgeClassMap = new Map<BadgeVariant,string>([[BadgeVariant.critical,styles.criticalBadge],[BadgeVariant.Success,styles.greenBadge]]);
    const badgeClass = badgeClassMap.get(props.kind);

    return (
        <Box className={`${styles.statusBadge} ${badgeClass}`}>
            <Box className={styles.inline}>
                <Checkbox
                className={classes.root}
                checked={props.state}
                disableRipple
                color="default"
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={handleChange}
            /><span className={classes.statusLabel}>
                {props.IStatusBadgeProps.name}</span>
                
            
        </Box>
        </Box>
    
    );
};
